'use client'; // Needed since Splide is a Class component (Can't be in a Server component)
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { EntityTileItem, type EntityTileItemProps } from '@/ui-components/molecules/EntityTileItem/EntityTileItem';
import { breadthOfContentSliderOptions } from '../breadthOfContentSliderOptions';
import { BreadthOfContentAccessibilityList } from '../BreadthOfContentAccessibilityList/BreadthOfContentAccessibilityList';
import { LinkWrapperIfHref } from '@/ui-components/atoms/LinkWrapperIfHref/LinkWrapperIfHref';

export interface BreadthOfEntityHeroesProps {
    items: EntityTileItemProps[];
}

export default function BreadthOfEntityHeroes({ items = [] }: BreadthOfEntityHeroesProps): React.JSX.Element {
    const accessibilityItems = items
        .flatMap(({ ariaLabel, href, children }, index) => {
            const heroLink = ariaLabel && (
                <LinkWrapperIfHref link={{ href }} key={index} forceContainer>
                    {ariaLabel}
                </LinkWrapperIfHref>
            );
            const listLink = children;

            return [heroLink, listLink];
        })
        .filter(Boolean);

    return (
        <BreadthOfContentAccessibilityList items={accessibilityItems}>
            <Splide
                options={breadthOfContentSliderOptions}
                hasTrack={false}
                aria-live="off"
                extensions={{ AutoScroll }}
            >
                <SplideTrack>
                    {items.map((item, index) => (
                        <SplideSlide key={index}>
                            <EntityTileItem {...item} />
                        </SplideSlide>
                    ))}
                </SplideTrack>
            </Splide>
        </BreadthOfContentAccessibilityList>
    );
}
